import { createSlice } from '@reduxjs/toolkit';
  
const videoDetailsSlice = createSlice({
    name: 'VideoDetailsData',
    initialState: {
            "authors": [],
            "conceptCode": [],
            "concepts": [],
            "completionPercent": 0,
            "favourites": [],
            "pages": [],
            "status": "DRAFT",
            "subjects": [],
            "pageState": {},
            "tags": [],
            "title": "",
            "videoUrl": "",
            "thumbnailUrl": "",
            "contentId": ""
    },
    reducers: {
        addVideoDetails: (state = {}, actionType = {}) => {
            return {...state, ...actionType.payload};
        },
    }
});

const { actions, reducer } = videoDetailsSlice;
export default reducer;
export const videoDetailsActions = actions;